import { fork, all } from 'redux-saga/effects';
import mineSaga from './mine';
import agentSaga from './agent';
import shareCodeSaga from './shareCode';
import upgradeSaga from './upgrade';
import saleOrderSaga from './saleOrder';
import courseSaga from './course';
import reportSaga from './report';
import customerSaga from './customer';
import teamSaga from './team';

export default function* memberSaga() {
  yield all([
    fork(agentSaga),
    fork(mineSaga),
    fork(shareCodeSaga),
    fork(upgradeSaga),
    fork(saleOrderSaga),
    fork(courseSaga),
    fork(reportSaga),
    fork(customerSaga),
    fork(teamSaga),
  ]);
}
